const getParent = () => {
  const parent = localStorage.getItem('PARENT_USER');
  if (parent) {
    return JSON.parse(parent);
  }
  return null;
};

export default getParent;